<template>
    <div class="mt-6">
        <label for="etapa-dropdown">Histórico das Etapas:</label>
        <div style="display: flex; gap: 10px; align-items: center">
            <Dropdown
                v-model="numeroEtapaSelecionada"
                :options="dropdownOptions"
                :disabled="isDisabled"
                optionLabel="label"
                optionValue="value"
                placeholder="Selecione uma etapa"
                id="etapa-dropdown"
            />
            <Button
                label="Voltar para Etapa"
                class="mt-2 ml-3"
                icon="pi pi-backward"
                :disabled="isDisabled || numeroEtapaSelecionada == null"
                @click="redirecionarEtapa"
            />
        </div>
    </div>
</template>

<script>
import service from './homologacao/service';

export default {
    name: 'DropdownEtapas',
    props: {
        etapasSolicitacaoDto: {
            type: Array,
            required: true,
            default: () => [],
        },
        solicitacao: {
            type: Object,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        anexos: {
            type: Array,
        },
        observacao: {
            type: String,
        },
    },
    data() {
        return {
            numeroEtapaSelecionada: null,
        };
    },
    computed: {
        dropdownOptions() {
            if (this.etapasSolicitacaoDto.length > 0) {
                const etapasParaRetornarNoDropdown = [];
                const ultimaEtapa = this.etapasSolicitacaoDto.reduce((prev, curr) => (new Date(curr.dataCadastro) > new Date(prev.dataCadastro) ? curr : prev));

                this.etapasSolicitacaoDto
                    .filter((etapaParaDropdown) => {
                        const isEtapaComDescricao = etapaParaDropdown.descricaoEtapa != null && etapaParaDropdown.descricaoEtapa !== '';
                        const isEtapaDiferenteDeClassificacaoEReclassificacao =
                            etapaParaDropdown.etapa !== 2 && etapaParaDropdown.etapa !== 3 && etapaParaDropdown.etapa !== 1;
                        const isEtapaAnteriorAEtapaAtual = etapaParaDropdown.etapa < ultimaEtapa.proximaEtapa;

                        return isEtapaComDescricao && isEtapaDiferenteDeClassificacaoEReclassificacao && isEtapaAnteriorAEtapaAtual;
                    })
                    .map((etapa) => ({
                        label: etapa.descricaoEtapa,
                        value: etapa.etapa,
                    }))
                    .forEach((etapaParaDropdown) => {
                        const isEtapaJaAdicionadaNoArrayDeRetornoDoDropDown =
                            etapasParaRetornarNoDropdown.length === 0 ||
                            etapasParaRetornarNoDropdown.filter((etapaRetornarDropdown) => etapaRetornarDropdown.value === etapaParaDropdown.value).length ===
                                0;

                        if (isEtapaJaAdicionadaNoArrayDeRetornoDoDropDown) {
                            etapasParaRetornarNoDropdown.push(etapaParaDropdown);
                        }
                    });

                return etapasParaRetornarNoDropdown.sort((a, b) => a.label.localeCompare(b.label));
            } else {
                return [];
            }
        },
    },
    methods: {
        redirecionarEtapa() {
            if (this.numeroEtapaSelecionada === null) return;

            this.$store.dispatch('addRequest');

            service
                .voltarEtapa(this.$route.params.id, this.solicitacao.proximaEtapa, this.numeroEtapaSelecionada, this.observacao, this.anexos)
                .then((response) => {
                    if (response && response.success) {
                        this.$toast.add({
                            severity: 'success',
                            detail: 'Solicitação encaminhada com sucesso',
                            life: 3000,
                        });
                        this.$router.push({
                            name: 'Licitacoes_Solicitacoes_Detalhar',
                        });
                    } else {
                        this.erros = response.erros;
                        this.$toast.add({
                            severity: 'error',
                            detail: 'Erro ao encaminhar solicitação!',
                            life: 3000,
                        });
                    }
                    location.reload();
                })
                .catch((error) => {
                    console.error('Erro na requisição:', error);
                    this.$toast.add({
                        severity: 'error',
                        detail: 'Erro ao processar a solicitação!',
                        life: 3000,
                    });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },
    },
};
</script>

<style scoped>
#etapa-dropdown {
    margin-top: 5px;
    padding: 5px;
    font-size: 1em;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>
